import { useMemo } from 'react';

export function useReadersBuildTable(inputs, t) {
  const headCells = useMemo(() => {
    return [
      { id: 'name', numeric: false, disablePadding: false, label: t('properties.name'), ellipsis: true },
      {
        id: 'ftpConfiguration',
        numeric: false,
        disablePadding: false,
        label: t('properties.ftpConfiguration'),
        ellipsis: true
      }
    ];
  }, [t]);

  const rows = useMemo(() => {
    if (!inputs) {
      return [];
    }
    return inputs.items.map(reader => ({
      name: reader.name,
      ftpConfiguration: reader.ftpConfiguration,
      canBeDeleted: !reader.hasRequests,
      id: reader.id
    }));
  }, [inputs]);

  return { headCells, rows };
}
